import type { ButtonHTMLAttributes } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** primary = gold 主 CTA（金不大面积铺底，仅主按钮）；secondary = 细描边 */
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}

/**
 * 基础按钮（M1 起按 08 开发文档补齐焦点环/热区规范；sm 用于后台表格行内操作，
 * 最小命中区仍 ≥36px——后台密度场景按 07 后台 PRD 适度收紧）。
 */
export function Button({ variant = 'primary', size = 'md', className, ...rest }: ButtonProps) {
  const classes = ['cs-btn', `cs-btn--${variant}`, `cs-btn--${size}`, className]
    .filter(Boolean)
    .join(' ');
  return <button type='button' className={classes} {...rest} />;
}
